import script from "./CountrySwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./CountrySwitch.vue?vue&type=script&setup=true&lang=js"

import "./CountrySwitch.vue?vue&type=style&index=0&id=7f491133&lang=css"

const __exports__ = script;

export default __exports__